import numeral from "numeral";
export function bytesFilter(value) {
    return numeral(value).format('0.0b');
}
